import * as log from "loglevel";
import * as React from "react";

import { inject, observer } from "mobx-react";
import { Button } from "semantic-ui-react";

import { ProjectStore } from "../../stores/project-store";
import { UserStore } from "../../stores/user-store";
import { LoadingSpinner } from "../common/loading-spinner";

interface IAdminViewProps{
	projectStore?: ProjectStore;
	userStore?: UserStore;
}

interface IAdminViewState{
}


@inject("projectStore", "userStore") @observer
export class SyncControls extends React.Component<IAdminViewProps, IAdminViewState>{
	constructor(props, state){
		super(props, state);
		this.handleSyncProjects = this.handleSyncProjects.bind(this);
		this.handleSyncUsers = this.handleSyncUsers.bind(this);
		this.handleSyncNonSurveyData = this.handleSyncNonSurveyData.bind(this);
		}


	handleSyncProjects(){
		this.props.projectStore.syncProjects();
	}

	handleSyncUsers(){
		this.props.userStore.syncUsers();
	}

	handleSyncNonSurveyData() {
		this.props.projectStore.syncNonSurveyData();
	}
	render(){
		return (
			<div>
				<Button className="jibunu-orange" onClick={this.handleSyncProjects} content="Sync Projects" />
				<Button className="jibunu-blue" onClick={this.handleSyncUsers} content="Sync Users" />
				<Button className="jibunu-green" onClick={this.handleSyncNonSurveyData} content="Sync Non-Survey Data" />
				{this.props.projectStore.loading &&
					<div>
						<LoadingSpinner text={"Syncing Projects"} />
					</div>
				}
				{this.props.projectStore.syncNonSurveyLoading &&
					<div>
						<LoadingSpinner text={"Syncing Non Survey Data"} />
					</div>
				}
				{this.props.userStore.loading &&
					<div>
						<LoadingSpinner text={"Syncing Users"} />
					</div>
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/admin/sync-controls.tsx